import React, { Component } from "react";
import { toast } from "react-toastify";
import Pagination from "react-js-pagination";
import SearchSharpIcon from "@material-ui/icons/SearchSharp";
import SaveAltSharpIcon from "@material-ui/icons/SaveAltSharp";
import { FormControl, InputGroup, Button, Form, FormGroup, Dropdown, Badge } from "react-bootstrap";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";

import axiosRequest from "axios";
import axios from "../../../axios";
import apiError from "../../../error";
import Loader from "../../../component/loader/loader";
import EVSGrid from "../../../component/evs/evs-grid/evs-grid";
import EVSTable from "../../../component/evs/evs-table/evs-table";
import EvsDetailDrawer from "../../../component/evs/evs-detail-drawer/evs-detail-drawer";
import { getAvatarInitials, getFullname } from "../../../component/evs/evs-utils";
import "react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css";

import "./evs-list.css";
import { PiArrowsClockwiseFill, PiX } from "react-icons/pi";

var cancelRequest = undefined, CancelToken = axiosRequest.CancelToken;

const EVS_RISK_ORDER = ["critical", "high", "medium", "low"];

/** Bar + legend order: Low → Medium → High → Critical */
const EVS_RISK_DISPLAY_ORDER = ["low", "medium", "high", "critical"];

const EVS_RISK_LABELS = {
	critical: "Critical",
	high: "High",
	medium: "Medium",
	low: "Low",
};

function parseRangeCounts(raw) {
	const out = { critical: 0, high: 0, medium: 0, low: 0 };
	if (!raw || typeof raw !== "object") return out;
	for (const k of EVS_RISK_ORDER) {
		const v = raw[k];
		const n = typeof v === "number" && Number.isFinite(v) ? v : parseInt(String(v ?? "").trim(), 10);
		out[k] = Number.isFinite(n) ? Math.max(0, n) : 0;
	}
	return out;
}

/** Accept `rangeCounts` nested object or `{ low, medium, high, critical }` at response root (string counts ok). */
function extractRangeCountsFromResponse(data) {
	if (!data || typeof data !== "object") return parseRangeCounts(null);
	const nested = data.rangeCounts ?? data.range_counts;
	if (nested && typeof nested === "object") return parseRangeCounts(nested);
	if (
		data.low != null ||
		data.medium != null ||
		data.high != null ||
		data.critical != null
	) {
		return parseRangeCounts({
			critical: data.critical,
			high: data.high,
			medium: data.medium,
			low: data.low,
		});
	}
	return parseRangeCounts(null);
}

function sumRangeCounts(counts) {
	return EVS_RISK_ORDER.reduce((sum, k) => sum + (counts[k] || 0), 0);
}

/** Bar width %: each bucket count / sum(low+medium+high+critical). */
function riskWidthsPercentFromCounts(counts) {
	const total = sumRangeCounts(counts);
	const out = {};
	if (total <= 0) {
		for (const k of EVS_RISK_ORDER) out[k] = 0;
		return out;
	}
	for (const k of EVS_RISK_ORDER) {
		out[k] = (counts[k] / total) * 100;
	}
	return out;
}

function distributedPercents(counts, total, decimals = 2) {
	const factor = Math.pow(10, decimals);
	const raws = EVS_RISK_DISPLAY_ORDER.map((k) =>
		total > 0 ? ((counts[k] || 0) / total) * 100 : 0
	);
	const floors = raws.map((v) => Math.floor(v * factor) / factor);
	let remainder = Math.round(
		(100 - floors.reduce((a, b) => a + b, 0)) * factor
	);
	const remainders = raws.map((v, i) => ({
		i,
		r: Math.round((v * factor) % 1),
	}));
	remainders.sort((a, b) => b.r - a.r);
	const result = [...floors];
	for (let j = 0; j < remainder; j++) {
		const idx = remainders[j % remainders.length].i;
		result[idx] =
			Math.round((result[idx] + 1 / factor) * factor) / factor;
	}
	const out = {};
	EVS_RISK_DISPLAY_ORDER.forEach((k, idx) => {
		out[k] = result[idx];
	});
	return out;
}

function coalesceTotalUsersCard(data, bucketSum) {
	const tu = data?.totalUsers ?? data?.total_users;
	if (tu != null && tu !== "") {
		const n = typeof tu === "number" ? tu : parseInt(String(tu), 10);
		if (Number.isFinite(n)) return n;
	}
	const cnt = data?.count;
	if (cnt != null && cnt !== "") {
		const n = typeof cnt === "number" ? cnt : parseInt(String(cnt), 10);
		if (Number.isFinite(n)) return n;
	}
	return bucketSum;
}

function coalesceAveragePercent(data) {
	const v = data?.averagePercent ?? data?.average_percent ?? data?.avgEvsPercent;
	if (v == null || v === "") return null;
	const n = typeof v === "number" ? v : parseFloat(String(v));
	return Number(n);
}

export default class EVS extends Component {
	constructor(props) {
		super(props);
		this.state = {
			evs: [],
			count: 0,
			limit: 10,
			// range: 100,
			search: "",
			type: false,
			activePage: 1,
			loading: true,
			filterPanelOpen: false,
			filterTab: "evs-score",
			filterDraftEvsMin: 0,
			filterDraftEvsMax: 100,
			filterDraftDepartment: "",
			filterDraftDesignation: "",
			filterDraftLocation: "",
			evsMin: 0,
			evsMax: 100,
			department: "",
			designation: "",
			location: "",
			departments: [],
			designations: [],
			locations: [],
			hasAppliedFilters: false,
			evsDrawerOpen: false,
			selectedEvs: null,
			evsAnalytics: {
				totalUsers: 0,
				averagePercent: 0,
				rangeCounts: {
					critical: 0,
					high: 0,
					medium: 0,
					low: 0,
				}
			}
		};
	}

	openEvsDrawer = (evs) => {
		this.setState({ evsDrawerOpen: true, selectedEvs: evs });
	};

	closeEvsDrawer = () => {
		this.setState({ evsDrawerOpen: false, selectedEvs: null });
	};

	componentDidMount = () => {
		this.fetchFilterOptions();
		this.load();
		const openEvs = this.props.location?.state?.openEvs;
		if (openEvs) {
			this.openEvsDrawer(openEvs);
			this.props.history.replace(this.props.location.pathname, {});
		}
	};

	fetchFilterOptions = () => {
		axios
			.get("/api/departments", {})
			.then((res) => this.setState({ departments: Array.isArray(res?.data?.departments) ? res.data.departments : [] }))
			.catch((error) => {
				this.setState({ departments: [] });
				apiError(error);
			});
		axios
			.get("/api/designations", {})
			.then((res) => this.setState({ designations: Array.isArray(res?.data?.designations) ? res.data.designations : [] }))
			.catch((error) => {
				this.setState({ designations: [] });
				apiError(error);
			});
		axios
			.get("/api/locations", {})
			.then((res) => this.setState({ locations: Array.isArray(res?.data?.locations) ? res.data.locations : [] }))
			.catch((error) => {
				this.setState({ locations: [] });
				apiError(error);
			});
	};

	getFilterOptionName = (list, id) => {
		if (id == null || id === "") return "";
		const item = (list || []).find((x) => String(x.id) === String(id));
		const name = item?.name;
		return name != null && name !== "" ? name : `ID: ${id}`;
	};

	nextPath = (path) => this.props.history.push(path);

	setFilterTab = (filterTab) => this.setState({ filterTab });

	setDraftEvsRange = (evsMin, evsMax) => {
		let min = Math.max(0, Math.min(100, parseInt(evsMin, 10) || 0));
		let max = Math.max(0, Math.min(100, parseInt(evsMax, 10) || 100));
		if (min > max) [min, max] = [max, min];
		this.setState({ filterDraftEvsMin: min, filterDraftEvsMax: max });
	};

	applyFilters = () => {
		this.setState({
			evsMin: this.state.filterDraftEvsMin,
			evsMax: this.state.filterDraftEvsMax,
			department: this.state.filterDraftDepartment || "",
			designation: this.state.filterDraftDesignation || "",
			location: this.state.filterDraftLocation || "",
			filterPanelOpen: false,
			activePage: 1,
			hasAppliedFilters: true,
		}, () => this.load());
	};

	/** Sentinel for "All" in selects (avoids clashing with a real id of "all"). */
	static EVS_FILTER_ALL = "__evs_all__";

	/** Select value: empty draft → All sentinel; otherwise string id. */
	evsFilterSelectValue = (draft) =>
		draft !== "" && draft != null ? String(draft) : EVS.EVS_FILTER_ALL;

	evsFilterSelectChange = (stateKey) => (e) => {
		const v = e.target.value;
		this.setState({ [stateKey]: v === EVS.EVS_FILTER_ALL ? "" : v });
	};

	getFilteredEvs = () => {
		const { evs, evsMin, evsMax, department, designation, location } = this.state;
		if (!evs || !evs.length) return [];
		return evs.filter((e) => {
			const score = parseInt(e.percent, 10) || 0;
			if (score < evsMin || score > evsMax) return false;
			const target = e.target || {};
			const evsDeptId = target.departmentId != null ? String(target.departmentId) : (target.department || "").trim();
			const evsDesigId = target.designationId != null ? String(target.designationId) : (target.job_title || target.jobTitle || target.designation || "").trim();
			const evsLocId = target.locationId != null ? String(target.locationId) : (target.location || "").trim();
			if (department && evsDeptId !== String(department)) return false;
			if (designation && evsDesigId !== String(designation)) return false;
			if (location && evsLocId !== String(location)) return false;
			return true;
		});
	};

	load = async () => {
		if (cancelRequest) cancelRequest();
		const {  evsMin, evsMax, department, designation, location, limit, search, activePage } = this.state;
		const hasAnyFilter = evsMin !== 0 || evsMax !== 100 || !!department || !!designation || !!location;
		// range: when filters applied use evsMax (same as commented range slider); otherwise use range (default 100)
		const params = {
			// range: rangeParam,
			limit,
			search,
			page: activePage,
		};
		if (hasAnyFilter) {
			if (evsMin > 0 || evsMax < 100) {
				params.minRange = evsMin;
				params.maxRange = evsMax;
			}
			if (department) params.departmentId = department;
			if (designation) params.designationId = designation;
			if (location) params.locationId = location;
		}
		axios
			.get("/api/evs", {
				params,
				cancelToken: new CancelToken(function executor(c) {
					cancelRequest = c;
				}),
			})
			.then((res) => {
				const data = res.data || {};
				const rangeCounts = extractRangeCountsFromResponse(data);
				const bucketSum = sumRangeCounts(rangeCounts);
				this.setState({
					loading: false,
					evs: data.evs || [],
					evsAnalytics: {
						rangeCounts,
						totalUsers: coalesceTotalUsersCard(data, bucketSum),
						averagePercent: coalesceAveragePercent(data),
					},
					count: data.count != null ? data.count : 0,
				});
			})
			.catch((error) => {
				if (!axiosRequest.isCancel(error)) {
					this.setState({
						evs: [],
						count: 0,
						loading: false,
						evsAnalytics: {
							totalUsers: 0,
							averagePercent: null,
							rangeCounts: { critical: 0, high: 0, medium: 0, low: 0 },
						},
					});
					apiError(error);
				}
			});
	};

	syncEvs = async () => {
		await this.setState({ loading: true });
		axios
			.get("/api/evs/sync", {})
			.then((res) => {
				this.setState({ loading: false });
				toast.warning(res.data.evs, { autoClose: 5000 });
			})
			.catch((error) => {
				this.setState({ loading: false });
				apiError(error);
			});
	};

	downloadFile = () => {
		this.setState({ loading: true });
		axios
			.get("/api/evs/csv", {})
			.then((response) => {
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "evs.csv");
				document.body.appendChild(link);
				link.click();
				this.setState({ loading: false });
			})
			.catch((err) => {
				this.setState({ loading: false });
				apiError(err);
			});
	};

	render() {
		const { rangeCounts } = this.state.evsAnalytics;
		const bucketSum = sumRangeCounts(rangeCounts || {});
		const mix = riskWidthsPercentFromCounts(rangeCounts || {}); 
		const displayPct = distributedPercents(rangeCounts || {}, bucketSum); 

		return (
			<div className="content-wrap" id="evs-wrap">
				<div className="breadcrumbbar">
					<div className="flexRow row">
						<div className="col-md-4">
							<div className="page-head d-flex align-items-center justify-content-between">
								<h4 className="page-title">Employee Vulnerability Score</h4>
							</div>
						</div>

						<div className="col-md-8 flexFilterButtons">
							<div className="btn-container float-right d-flex align-items-center">
								<Button variant="primary" onClick={this.downloadFile}><SaveAltSharpIcon className="btn-icon"></SaveAltSharpIcon>Export CSV</Button>
							</div>
						</div>
					</div>
				</div>

				<div className="contentbar grey-bg">


					<div className="mb-4">
						<div className="row">
							<div className="col-md-3">
								<div className="analytic-data-wrap">
									<div className="analytic-data-item">
										<p className="analytic-data-item-label">Total Users</p>
										<p className="analytic-data-item-value">{this.state.evsAnalytics.totalUsers ?? 0}</p>
									</div>
									<div className="analytic-data-item">
										<p className="analytic-data-item-label">Avg EVS</p>
										<p className="analytic-data-item-value analytic-data-item-value--accent">
											{this.state.evsAnalytics.averagePercent != null
												? `${this.state.evsAnalytics.averagePercent}%`
												: "—"}
										</p>
									</div>
								</div>

							</div>
							<div className="col-md-9 d-flex align-items-center pl-0">
								<div className="evs-risk-distribution w-100">
									<h6 className="analytic-data-item-heading">Risk Distribution</h6>
									<div
										className={`evs-risk-distribution__bar ${bucketSum === 0 ? "evs-risk-distribution__bar--empty" : ""}`}
										role="img"
										aria-label={EVS_RISK_DISPLAY_ORDER.map((k) => {
											const pctVal = bucketSum > 0 ? mix[k] : 0;
											return `${EVS_RISK_LABELS[k]} ${pctVal.toFixed(2)}%`;
										}).join(", ")}
									>
										{bucketSum === 0
											? null
											: EVS_RISK_DISPLAY_ORDER.map((key) => {
													const pct = mix[key];
													const n = rangeCounts[key] || 0;
													return (
														<div
															key={key}
															className={`evs-risk-distribution__segment evs-risk-distribution__segment--${key}`}
															style={{ width: `${pct}%` }}
															title={`${EVS_RISK_LABELS[key]}: ${n} users (${Number(pct.toFixed(2))}% of ${bucketSum})`}
														/>
													);
											  })}
									</div>
									<div className="evs-risk-distribution__legend mt-2 d-flex flex-wrap align-items-center">
										{EVS_RISK_DISPLAY_ORDER.map((key) => {
											const n = rangeCounts[key] || 0;
											const pct = displayPct[key]; // guaranteed to sum to 100
											return (
												<span key={key} className="evs-risk-distribution__legend-item mr-3">
													<span className={`evs-risk-distribution__dot evs-risk-distribution__dot--${key}`} />
													<span className="evs-risk-distribution__legend-label">{EVS_RISK_LABELS[key]}</span>
													<strong className="evs-risk-distribution__legend-value">{n}</strong>
													<span className="evs-risk-distribution__legend-count"> ({Number(pct.toFixed(2))}%) </span>
												</span>
											);
										})}
									</div>
								</div>

							</div>
						</div>
					</div>

					<div className="filter-without-border">
						<div className="align-items-center row">
							<div className="col-md-3">
								<div className="positionSearchIcon">
									<InputGroup className="search-wrap">
										<FormControl
											type="text"
											placeholder="Search"
											className="inputSearch mr-sm-2 form-control"
											value={this.state.search}
											onChange={(e) =>
												this.setState(
													{ search: e.target.value, activePage: 1 },
													() => this.load()
												)
											}
										/>
										<SearchSharpIcon className="search-icon"></SearchSharpIcon>
									</InputGroup>
								</div>
							</div>

							<div className="col-sm-9">
								<div className="rightFilters">

									<div className="sync-outline-btn mr-2" disabled={this.state.loading} onClick={this.syncEvs}><PiArrowsClockwiseFill size={20} /></div>
									<Dropdown className="d-inline-block mr-2">
										<Dropdown.Toggle variant="secondary" id="limit-dropdown" className="dropdown-color-white">
											{this.state.limit}
										</Dropdown.Toggle>
										<Dropdown.Menu>
											{[10, 25, 50, 100].map((limit) => (
												<Dropdown.Item
													key={`limit-${limit}`}
													onClick={() => this.setState({ limit: limit, activePage: 1 }, () => this.load())}
													active={this.state.limit === limit}
												>
													{limit}
												</Dropdown.Item>
											))}
										</Dropdown.Menu>
									</Dropdown>
									<Dropdown
										show={this.state.filterPanelOpen}
										onToggle={(isOpen) => this.setState({
											filterPanelOpen: isOpen,
											...(isOpen ? {
												filterDraftEvsMin: this.state.evsMin,
												filterDraftEvsMax: this.state.evsMax,
												filterDraftDepartment: this.state.department,
												filterDraftDesignation: this.state.designation,
												filterDraftLocation: this.state.location,
											} : {}),
										})}
									>
										<Dropdown.Toggle variant="secondary" id="evs-filter-dropdown" className="dropdown-color-white">
											Filter
										</Dropdown.Toggle>
										<Dropdown.Menu className="filter-panel-dropdown p-0" style={{ minWidth: "360px" }}>
											<div className="d-flex">
												<div className="filter-vertical-tabs border-right" style={{ width: "120px", minHeight: "280px" }}>
													<button
														type="button"
														className={`d-block w-100 vertical-tab-item text-left ${this.state.filterTab === "evs-score" ? "active" : ""}`}
														style={{ fontSize: "13px" }}
														onClick={() => this.setFilterTab("evs-score")}
													>
														EVS Score
													</button>

													<button
														type="button"
														className={`d-block w-100 vertical-tab-item ${this.state.filterTab === "designation" ? "active" : ""}`}
														style={{ fontSize: "13px" }}
														onClick={() => this.setFilterTab("designation")}
													>
														Designation
													</button>

													<button
														type="button"
														className={`d-block w-100 vertical-tab-item ${this.state.filterTab === "department" ? "active" : ""}`}
														style={{ fontSize: "13px" }}
														onClick={() => this.setFilterTab("department")}
													>
														Department
													</button>
													
													<button
														type="button"
														className={`d-block w-100 vertical-tab-item ${this.state.filterTab === "location" ? "active" : ""}`}
														style={{ fontSize: "13px" }}
														onClick={() => this.setFilterTab("location")}
													>
														Location
													</button>
												</div>
												<div className="filter-tab-content flex-grow-1" style={{ minHeight: "280px" }}>
													{this.state.filterTab === "evs-score" && (
														<>
															<h6 className="mb-3 filter-heading">Select EVS Score Range</h6>
															<div className="filter-content-wrapper">
																<div className="health-range-slider-wrapper position-relative" style={{ paddingTop: "0px" }}>
																	<InputRange
																		minValue={0}
																		maxValue={100}
																		value={{ min: this.state.filterDraftEvsMin, max: this.state.filterDraftEvsMax }}
																		onChange={(value) => this.setDraftEvsRange(value.min, value.max)}
																	/>
																</div>
																<div className="d-flex justify-content-between" style={{ fontSize: "11px", color: "#6c757d" }}><span>0%</span><span>100%</span></div>
																<div className="filter-health-range-wrapper d-flex justify-content-between align-items-center">
																	<p>{this.state.filterDraftEvsMin}% - {this.state.filterDraftEvsMax}%</p>
																</div>
															</div>
														</>
													)}
													{this.state.filterTab === "department" && (
														<>
															<h6 className="mb-3 filter-heading">Select Department</h6>
															<div className="filter-content-wrapper">
																<FormControl
																	as="select"
																	value={this.evsFilterSelectValue(this.state.filterDraftDepartment)}
																	className="form-control"
																	onChange={this.evsFilterSelectChange("filterDraftDepartment")}
																>
																	<option value="" disabled>Select Department</option>
																	<option value={EVS.EVS_FILTER_ALL}>All</option>
																	{(this.state.departments || []).map((d, i) => (
																		<option key={`dept-${d.id}-${i}`} value={String(d.id)}>{d.name != null && d.name !== "" ? d.name : `ID: ${d.id}`}</option>
																	))}
																</FormControl>
															</div>
														</>
													)}
													{this.state.filterTab === "designation" && (
														<>
															<h6 className="mb-3 filter-heading">Select Designation</h6>
															<div className="filter-content-wrapper">
																<FormControl
																	as="select"
																	value={this.evsFilterSelectValue(this.state.filterDraftDesignation)}
																	className="form-control"
																	onChange={this.evsFilterSelectChange("filterDraftDesignation")}
																>
																	<option value="" disabled>Select Designation</option>
																	<option value={EVS.EVS_FILTER_ALL}>All</option>
																	{(this.state.designations || []).map((d, i) => (
																		<option key={`desig-${d.id}-${i}`} value={String(d.id)}>{d.name != null && d.name !== "" ? d.name : `ID: ${d.id}`}</option>
																	))}
																</FormControl>
															</div>
														</>
													)}
													{this.state.filterTab === "location" && (
														<>
															<h6 className="mb-3 filter-heading">Select Location</h6>
															<div className="filter-content-wrapper">
																<FormControl
																	as="select"
																	value={this.evsFilterSelectValue(this.state.filterDraftLocation)}
																	className="form-control"
																	onChange={this.evsFilterSelectChange("filterDraftLocation")}
																>
																	<option value="" disabled>Select Location</option>
																	<option value={EVS.EVS_FILTER_ALL}>All</option>
																	{(this.state.locations || []).map((l, i) => (
																		<option key={`loc-${l.id}-${i}`} value={String(l.id)}>{l.name != null && l.name !== "" ? l.name : `ID: ${l.id}`}</option>
																	))}
																</FormControl>
															</div>
														</>
													)}
												</div>
											</div>
											<div className="filter-panel-footer p-2 border-top d-flex justify-content-end">
												<Button variant="primary" size="md" onClick={this.applyFilters}>Apply</Button>
											</div>
										</Dropdown.Menu>
									</Dropdown>
								</div>
							</div>
						</div>
					</div>

					{(() => {
						const hasAnyFilter = this.state.evsMin !== 0 || this.state.evsMax !== 100 || !!this.state.department || !!this.state.designation || !!this.state.location;
						return hasAnyFilter && (
							<div className="applied-filters-bar d-flex align-items-center flex-wrap">
								{(this.state.evsMin !== 0 || this.state.evsMax !== 100) && (
									<Badge variant="secondary" className="applied-filter-badge badge-soft-primary-filter d-inline-flex align-items-center mr-2">
										EVS Score: {this.state.evsMin}% - {this.state.evsMax}%
										<PiX className="ml-1 filter-badge-close" style={{ cursor: "pointer", fontSize: "14px" }} onClick={() => {
											const { department, designation, location } = this.state;
											this.setState({ evsMin: 0, evsMax: 100, activePage: 1, hasAppliedFilters: !!(department || designation || location) }, () => this.load());
										}} />
									</Badge>
								)}
								{this.state.department && (
									<Badge variant="secondary" className="applied-filter-badge badge-soft-primary-filter d-inline-flex align-items-center mr-2">
										Department: {this.getFilterOptionName(this.state.departments, this.state.department)}
										<PiX className="ml-1 filter-badge-close" style={{ cursor: "pointer", fontSize: "14px" }} onClick={() => {
											const { evsMin, evsMax, designation, location } = this.state;
											this.setState({ department: "", activePage: 1, hasAppliedFilters: evsMin !== 0 || evsMax !== 100 || !!designation || !!location }, () => this.load());
										}} />
									</Badge>
								)}
								{this.state.designation && (
									<Badge variant="secondary" className="applied-filter-badge badge-soft-primary-filter d-inline-flex align-items-center mr-2">
										Designation: {this.getFilterOptionName(this.state.designations, this.state.designation)}
										<PiX className="ml-1 filter-badge-close" style={{ cursor: "pointer", fontSize: "14px" }} onClick={() => {
											const { evsMin, evsMax, department, location } = this.state;
											this.setState({ designation: "", activePage: 1, hasAppliedFilters: evsMin !== 0 || evsMax !== 100 || !!department || !!location }, () => this.load());
										}} />
									</Badge>
								)}
								{this.state.location && (
									<Badge variant="secondary" className="applied-filter-badge badge-soft-primary-filter d-inline-flex align-items-center mr-2">
										Location: {this.getFilterOptionName(this.state.locations, this.state.location)}
										<PiX className="ml-1 filter-badge-close" style={{ cursor: "pointer", fontSize: "14px" }} onClick={() => {
											const { evsMin, evsMax, department, designation } = this.state;
											this.setState({ location: "", activePage: 1, hasAppliedFilters: evsMin !== 0 || evsMax !== 100 || !!department || !!designation }, () => this.load());
										}} />
									</Badge>
								)}
							</div>
						);
					})()}

					<div className=" evs-table-scroll-wrapper">
						<div className="evs-table-list">
							{this.state.evs && this.state.evs.length ? (
								this.state.evs.map((e, index) => (
									<EVSTable
										evs={e}
										key={e.id != null ? e.id : index}
										nextPath={this.nextPath}
										onDownload={this.downloadFile}
										onViewEvs={this.openEvsDrawer}
									/>
								))
							) : (
								<h6 className="evs-no-data-found">No EVS Record Found</h6>
							)}
						</div>
					</div>
					{

					this.state.evs && this.state.evs.length > 0 && (
					<div className="pagination-Wrap">
						<div className="row">
							<div className="col-md-6">
								{!this.state.loading ? (
									<Pagination
										itemClass="page-item"
										linkClass="page-link"
										activePage={this.state.activePage}
										itemsCountPerPage={this.state.limit}
										totalItemsCount={this.state.count}
										onChange={(pageNumber) =>
											this.setState({ activePage: pageNumber }, () => this.load())
										}
									/>
								) : (
									<Loader></Loader>
								)}
							</div>
							<div className="col-md-6 text-right d-flex align-items-center footer-pg">
							<div className="w-100 pgCount">
                                                <p>{this.state.count === 0 ? 0 : this.state.activePage * this.state.limit + 1 - this.state.limit}-
                                                    {this.state.activePage * this.state.limit > this.state.count ? this.state.count : this.state.activePage * this.state.limit} of {this.state.count} records</p>
                                            </div>
							</div>
						</div>
					</div>
					)}
				</div>

				<EvsDetailDrawer
					show={this.state.evsDrawerOpen}
					onHide={this.closeEvsDrawer}
					evs={this.state.selectedEvs}
					fullname={this.state.selectedEvs?.target ? getFullname(this.state.selectedEvs.target.firstname, this.state.selectedEvs.target.lastname) : "-"}
					avatarInitial={this.state.selectedEvs?.target ? getAvatarInitials(this.state.selectedEvs.target.firstname, this.state.selectedEvs.target.lastname) : "?"}
				/>
			</div>
		);
	}
}